module.exports = __webpack_public_path__ + "img/prize3.895a95c1.png";